import React, { useState } from 'react'
import { useStore } from '../../../StateProvider'
import { useResidenceDependentVisibility } from '../../utils/hooks'
import { ExternalSwiftCode } from '..'

const residenceDependentFields = ['swiftCode']

const ExternalSwiftCodeCountryDependent = ({ i18n, type, name, maxlength, additionalInfo, required, requiredForCountries }) => {
  const [isShown, setIsShown] = useState(true)
  const [{ form, form: { accId } }, dispatch] = useStore()
  const { residenceCountry } = form[accId]

  const onHide = () => {
    setIsShown(false)
    dispatch({ type: 'removeValidationFld', name })
  }

  const onShow = () => {
    setIsShown(true)
    dispatch({ type: 'addValidationFld', name })
  }

  useResidenceDependentVisibility({
    residenceCountry, requiredForCountries, name, residenceDependentFields, onHide, onShow
  })

  return isShown ? (
    <ExternalSwiftCode
      name={name}
      i18nLabel={i18n}
      type={type}
      required={required}
    />
  ) : null
}

const getExternalSwiftCodeCountryDependentFields = textField => {
  return (<ExternalSwiftCodeCountryDependent {...textField} key={textField.name} />)
}

export { ExternalSwiftCodeCountryDependent, getExternalSwiftCodeCountryDependentFields }
